import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogItemStaff } from "./CatalogItemStaff";
import type { CatalogRef } from "./CatalogRef";
import type { CatalogStaff } from "./CatalogStaff";
import type { ProductDTOBase } from "./ProductDTOBase";
import type { TrackedModernBase } from "./TrackedModernBase";

export class ProductStaff implements ProductDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly catalogId: CatalogStaff | null, public readonly productName: string, public readonly productDescription: string, public readonly active: boolean, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly items: Array<CatalogItemStaff> | null, public readonly catalogIdTargetIds: CatalogRef) {
    this.cbiServiceContext = null;
    this.catalogIdLoaded = this.catalogId != null;
    this.catalogIdCached = this.catalogId;
    this.itemsLoaded = this.items != null;
    this.itemsCached = this.items;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private catalogIdLoaded: boolean;
  private catalogIdCached: CatalogStaff | null;
  private itemsLoaded: boolean;
  private itemsCached: Array<CatalogItemStaff> | null;
  async catalogIdLazy(): Promise<CatalogStaff> {
    if (!this.catalogIdLoaded) {
      this.catalogIdCached = await this.cbiServiceContext!.catalogService().getCatalogStaff(this.catalogIdTargetIds.assignId);
      this.catalogIdLoaded = true;
    }
    return this.catalogIdCached!;
  }
  async itemsLazy(): Promise<Array<CatalogItemStaff>> {
    if (!this.itemsLoaded) {
      this.itemsCached = await this.cbiServiceContext!.catalogService().getProductStaffItems(this.assignId);
      this.itemsLoaded = true;
    }
    return this.itemsCached!;
  }
}
